import axiosWithInterceptor from '../services/axiosWithInterceptor';
import { ORDER_MICRO_SERIVCE, ORDER_SERVICE } from '../constants';
import type { IGetCartPayload } from '../models/order.model';

/**
 * Analytics-only get-cart read. Uses axios directly (no orderMicroService
 * cancel token) so CartModal sync cancel does not abort this request.
 */
export async function pulseGetCart(payload: IGetCartPayload) {
  const response = await axiosWithInterceptor.get(
    `${ORDER_MICRO_SERIVCE}/${ORDER_SERVICE}`,
    { params: payload },
  );
  return response?.data?.data ?? null;
}
